import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { userManualDialogChapters } from '../../../../state/dialogs/chapters';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { ImageLoader } from '../../../ImageLoader';

export const ActivatingServicesChapter: React.FC = () => {
  const { locale } = useLocale();

  const activatingServices1 = getImageAssetWithLocale(
    imageKeys.activatingServices1,
    locale,
  );
  const activatingServices2 = getImageAssetWithLocale(
    imageKeys.activatingServices2,
    locale,
  );

  const activatingServicesActivateText =
    'userManual.activatingServices.activateDeactivateService.text';

  return (
    <div className={'row'}>
      <ChapterHeadline messageId={'userManual.activatingServices.headline'} />
      <ChapterText
        messageId={
          'userManual.activatingServices.activateServiceForVehicle.text'
        }
        referenceToChapter={userManualDialogChapters.addingServiceCards}
      />
      <div
        className={
          'col-xs-12 row-xs-12 display-flex justify-content-around align-items-start max-width-100pct'
        }
      >
        <ImageLoader
          src={activatingServices1}
          className="border-style-solid border-width-1 border-color-light rounded col-xs-5 row-xs-12 margin-bottom-25 max-width-40pct height-auto"
        />
        <ImageLoader
          src={activatingServices2}
          className="border-style-solid border-width-1 border-color-light rounded col-xs-5 row-xs-12 margin-bottom-25 max-width-40pct height-auto"
        />
      </div>
      <ChapterText messageId={activatingServicesActivateText} />
    </div>
  );
};
